// Đây là toàn bộ các thông tin có thể config trong trang web admin
// Ngày cập nhật cuối: 22/8/2025
// Tác giả: Hưng Đẹp Trai

// TypesPage: là các type màn hình cơ bản có thể cấu hình trong màn hình /config-screens (Đây là nơi config url nào, type page là gì, api chính của page là gì)
const TypesPage = {
  // Màn hình dạng table
  table: "table",
  // Màn hình dạng tab, mỗi tab là 1 page con
  tab: "tab",
  // Màn hình dạng panel là dạng thể hiện các màn hình con luôn tuồng từ trên xuống dưới
  panel: "panel",
}

// TypesTableCell: là các type table cell cơ bản có thể cấu hình trong màn hình table
const TypesTableCell = {
  //những kiểu lưu giá trị là string, text
  text: "text", // ô dạng input, ko có xuống dòng
  textarea: "textarea", // ô dạng textarea, có hiển thị xuống dòng được
  //những kiểu lưu giá trị là số
  number: "number", // ô dạng input, chỉ cho nhập số, giá trị lưu là string
  //những kiểu lưu giá trị là dạng ngày như: số milisecond theo giờ UTC, ngày dạng text
  date: "date", // ô dạng show popup chọn ngày, giá trị lưu là số milisecond
  //những kiểu lưu giá trị là string dạng json
  json_editor: "json_editor", // ô dạng json viewer, click vào show modal trình bày json string đẹp dễ chỉnh sửa hơn, giá trị lưu là json string
  //những kiểu lưu giá trị là string, là value từ 1 danh sách options
  select2_modal: "select2_modal", // select từ options của page, nhưng do số lượng nhiều nên show trong modal, có phân trang, search
  select2_modal_api: "select2_modal_api", // tương tự select2_modal, nhưng do data nhiều nên tự request api lấy options, tránh làm nặng page
  //những kiểu cho upload file, lưu giá trị là object có các thông tin file, đường dẫn file v.v...
  files: "files",
  //những kiểu action, thực thi, giá trị để sử dụng cho tùy mục đích khác nhau
  api: "api", // ô dạng nút, nhấn để gọi api
  form: "form", // ô dạng nút, nhấn show form để submit
}

// TypesHeaderButtons: là các type header button cơ bản
const TypesHeaderButtons = {
  link: "link", // click vào mở link
  api: "api", // click vào gọi api
  form: "form", // click vào mở modal là 1 form
}

// KMTC: là các key config more cho table cell
// Cách config: Vào màn hình config page -> Chọn field tương ứng -> Edit ô More -> Nhập key cần config trong json editor cùng giá trị của nó rồi lưu lại
// Lưu ý: mỗi config more có thể phụ thuộc vào type cell để có thể hoạt động được hay không
// Màn hình config page là màn hình riêng cho từng màn hình, thông thường có thể vào bằng cách nhấn nút setting trên danh sách buttons của page. Thường có đường dẫn kiểu: /data-table-setting-single/[ScreenCode của Page]
// Với ghi chú có Ref là chỉ nơi chi chú chi tiết hơn cho object đó
export const KMTC = {
  rel: "rel", //dùng cho type link, custom rel của thẻ a
  badge: "badge", //tương tự configBadge, Ref: cell.more.configBadge
  configBadge: "configBadge", //dùng để show thêm số cho nút trên cell, Ref: cell.more.configBadge
  configPinmap: "configPinmap", //config cho cell hiển thị dạng pin map, Ref: cell.more.configPinmap
  usingI18n: "usingI18n",
  className: "className",
  style: "style",
  styleByValue: "styleByValue",
  styleDisabled: "styleDisabled",
  configIcon: "configIcon",
  configCheckbox: "configCheckbox",
  icon: "icon", // cho select_icon v.v..
  ignoreLockedRow: "ignoreLockedRow",
  disabledUnselect: "disabledUnselect",
  linkTitle: "linkTitle",
  fLinkTitle: "fLinkTitle",
  canEditF: "canEditF",
  fCanEdit: "fCanEdit",
  newWindow: "newWindow",
  showPhoto: "showPhoto",
  styledCSS: "styledCSS",
  maxHeight: "maxHeight",
  maxWidth: "maxWidth",
  noScale: "noScale",
  styleImg: "styleImg",
  styleImage: "styleImage", //style image dùng trong type files
  styleImagePlaceholder: "styleImagePlaceholder", //style image placeholder dùng trong type files
  photoEmpty: "photoEmpty", //url photo thay thế image placeholder mặc định, có thể là base64
  hidePhotoWhenEmpty: "hidePhotoWhenEmpty", //không show gì nếu ko có hình gì show ra ở type files
  link: "link",
  list: "list", //mảng các danh sách items tùy theo type cell như list_text, list_expand
  fLink: "fLink",
  color: "color",
  collapseAllExpandAfterRequestApi: "collapseAllExpandAfterRequestApi", //tự động tắt hết các expand sau khi gọi api
  fColor: "fColor",
  min: "min",
  fMin: "fMin",
  max: "max",
  fMax: "fMax",
  styleInput: "styleInput",
  styleControl: "styleControl",
  styledCSSHTMLViewer: "styledCSSHTMLViewer",
  classNameHTMLViewer: "classNameHTMLViewer",
  classNameWithColField: "classNameWithColField",
  classNameDisabled: "classNameDisabled",
  classNameCell: "classNameCell",
  modal: "modal",
  placeHolder: "placeHolder",
  format: "format",
  dateFormat: "dateFormat",
  datetimeFormat: "datetimeFormat",
  dateTextFormat: "dateTextFormat",
  fBorderLeftColor: "fBorderLeftColor",
  configPage: "configPage",
  configApi: "configApi",
  configPagination: "configPagination",
  fSelectValue: "fSelectValue", //for select2_modal_table
  query: "query",
  fDisplay: "fDisplay", // sử dụng field khác để show thay vì chính field của nó
  querySelectValue: "querySelectValue", //for form_modal_table
  queryFromParent: "queryFromParent", //dung trong kieu expand api -> bo sung query lay tu parent
  queryWithQuerySharedPage: "queryWithQuerySharedPage", //boolean: query request bo sung them tu _onePage.getQueryShared()
  clickToSelect: "clickToSelect",
  noFormat: "noFormat", //dùng cho kiểu number, khi ko muốn format auto
  button: "button", //config nút cho các cell show nút ra như api, modal. Ref: cell.more.button
  cbNormal: "cbNormal", //for checkbox
  cbPositive: "cbPositive", //for checkbox
  cbNegative: "cbNegative", //for checkbox
  configEditIcon: "configEditIcon", //
  configFileIcon: "configFileIcon",
  configAddable: "configAddable", //config cho vùng add new giá trị cho options của select_addable
  configFile: "configFile", //config cho type files, Ref: cell.more.configFile
  file: "file", //alias cho more.configFile, Ref: cell.more.configFile
  configTextDisplay: "configTextDisplay", //config text display {fDisplay,fShow,hasIconAndText,fIcon,icon}
  typeAdmin: "typeAdmin", //type danh rieng cho trang admin neu can thiet
  titleConfirm: "titleConfirm", //title cho thông báo xác nhận
  titleExpand: "titleExpand",
  defaultShowAllButtonsMini: "defaultShowAllButtonsMini", //config cho type expand, có show ra hết nút ở vùng header button của vùng expand hay ko
  showHeaderMini: "showHeaderMini", //config cho type expand, có show header cho table expand hay ko
  total: "total",
  allowHalf: "allowHalf",
  allowClear: "allowClear",
  confirmMsg: "confirmMsg", //truoc khi click api v.v..
  fConfirmMsg: "fConfirmMsg", //f confirmMsg
  myui: "myui",
  styleByValueField: "styleByValueField", //styleByValueField or logic
  showDisplayWithMyUI: "showDisplayWithMyUI", //custom display bang myui
  showClear: "showClear", //show nut clear
  configClear: "configClear",
  hideWhenEmpty: "hideWhenEmpty",
  hideWhenNull: "hideWhenNull",
  fHideWhenNull: "fHideWhenNull",
  fHideWhenEmpty: "fHideWhenEmpty",
  fHide: "fHide",
  fDisplayWhenHide: "fDisplayWhenHide", //dùng field này để show ra khi cell ở chế độ ẩn
  showDeleteRow: "showDeleteRow", //show nut clear row o right top bar
  showPreviewHTML: "showPreviewHTML", //show nut preview HTML
  showModalMultiLanguage: "showModalMultiLanguage", //bổ sung nút mở màn hình cấu hình ngôn ngữ
  configModalMultiLanguage: "configModalMultiLanguage",
  showTestCanEdit: "showTestCanEdit",
  configDisplay: "configDisplay", //bo sung config display cho cac cell show text
  virtualized: "virtualized", //ho tru virtualized true/false
  showRemoveInItemSelected: "showRemoveInItemSelected", //show nút remove item khi show modal ở kiểu select2_modal, thay vì click vào item đã chọn để remove
  virtualizedMin: "virtualizedMin", //chuyen qua virtualized khi co min size la bao nhieu
  showSelectedOnFirstRow: "showSelectedOnFirstRow", //show selected item on first row, select modal
  apiCheckShowModal: "apiCheckShowModal", //check show modal o form
  autoOpenLink: "autoOpenLink", // auto open full path
  overideDefaultValues: "overideDefaultValues", //data truyen len se bao gom default Values, hien tai mac dinh se gom default values nen ko su dung nua
  rows: "rows",
  needReExpand: "needReExpand",
  needReloadOptionsAndList: "needReloadOptionsAndList",
  needReloadRow: "needReloadRow",
  needReload: "needReload",
  needReloadMaster: "needReloadMaster",
  needReloadList: "needReloadList",
  needReloadTable: "needReloadTable",
  needReloadPage: "needReloadPage",
  needReloadListMain: "needReloadListMain", //bo sung needReloadListMain cho reload tu table mo tu button modal_page
  needReloadOptionsAndListMain: "needReloadOptionsAndListMain", //bo sung for main page
  needSendMsg: "needSendMsg",
  configFormat: "configFormat", //danh cho config format mac dinh ma cell su dung
  configProgress: "configProgress", //danh cho progress
  configPopover: "configPopover", //danh cho co su dung popover
  configTitleTooltip: "configTitleTooltip", //config title tooltip. Ref: cell.more.configTitleTooltip
  configTooltip: "configTooltip", //config tooltip
  canShow: "canShow", //co show hay ko tu more
  fCanShow: "fCanShow",
  hideOfIds: "hideOfIds", //an dua theo Id
  showBlockMobile: "showBlockMobile",
  configWarning: "configWarning", //bo sung show icon warning kem tooltip
  alwayShow: "alwayShow", //luon muon show cell khi thoa man dieu kien hide
  isNegative: "isNegative", //bool, cho phép số âm hay không, nếu là false thì ko cho phép
  noDecimal: "noDecimal",
  acceptType: "acceptType", //file type dc phep upload
  alwayShowSelectValueIfNoText: "alwayShowSelectValueIfNoText", //@default true, gán false nếu ko muốn hiển thị value select nếu ko có data trong source data
  configApiSourceData: "configApiSourceData", //config api get source data cho type array_editable_modal_api
  prefixImgBase64: "prefixImgBase64", //bổ sung khúc dầu data cho hình dạng base64, vd: data:image/png;base64, dành cho data cell chỉ chứa base64 của hình, thiếu đoạn format đầu, dùng cho type readonly_imgbase64
  canClickToView: "canClickToView", // nếu bằng true khi click vào sẽ mở modal để xem rõ hơn, dùng cho type readonly_imgbase64
  apiUpload: "apiUpload",
  pathUrl: "pathUrl",
  typeInput: "typeInput", //chuyen doi textarea va input
  typeDisabled: "typeDisabled", //chuyen type khac khi disabled
  fValue: "fValue", //dung xac dinh field Value khi muon thay doi
  fText: "fText", //dung xac dinh field Text khi muon thay doi
  hideZero: "hideZero", //an show khi value = 0
  fPhoto: "fPhoto", //link photo o type link
  html: "html", //dung cho kieu su dung html
  fHtml: "fHtml", //dung cho kieu su dung html
  multi: "multi", //dung cho cac kieu select ho tro multi
  usingText: "usingText", // select_icon
  usingIconFont: "usingIconFont", // select_icon
  styleIcon: "styleIcon", // select_icon
  styleText: "styleText", // select_icon
  styleTextarea: "styleTextarea",
  updateUIRelative: "updateUIRelative", //update UI cell khac sau khi update field, string cach nhau dau ,
  keyControlDateTime: "keyControlDateTime", //luon render child component trong cell khi render cell
  fDefaultValues: "fDefaultValues", //field trong row làm default values của form, nếu = "row" -> row làm default values
  customDefaultValues: "customDefaultValues", //gán custom các field của row làm default values của form
  defaultValuesForm: "defaultValuesForm", //gán 1 object cố định làm default values của form
  excludeDefaultValues: "excludeDefaultValues",
  htmlEditorLib: "htmlEditorLib",
  htmlEditorConfig: "htmlEditorConfig",
  moreProps: "moreProps",
  customConfig: "customConfig",
  configForm: "configForm",
  formConfig: "formConfig",
  fConfigForm: "fConfigForm",
  canDeselect: "canDeselect",
  autoTextWB: "autoTextWB", //tu dong set color trang den neu co set bgF
  styleInherit: "styleInherit", //ke thua style tu wrap
  editorAddFields: "editorAddFields", //danh sách field có thể bỏ vào editor
  defaultShowExpand: "defaultShowExpand", //dung cho kieu expand
  maxChar: "maxChar",
  maxCharUnicode: "maxCharUnicode",
  allowOver: "allowOver",
  jsonview: "jsonview", //config cho table cell type json_editor, là 1 object gồm có: defaultTab (là string gồm text,json,textarea,monaco, default là text)
  pathDataInJsonString: "pathDataInJsonString",
  useCacheForDOMMeasurements: "useCacheForDOMMeasurements", //bat useCacheForDOMMeasurements cho textareafull
  needLoadingFullRow: "needLoadingFullRow", //loading full row khi update
  noReplaceData: "noReplaceData", //danh cho kieu getTextWithData ko muon replace data
  waitApi: "waitApi", // show loading wheen api requesting
  animation: "animation", //name of animation
  screenCodeNeedExpand: "screenCodeNeedExpand", //api gọi cần expand row
  customRowBeforeRequest: "customRowBeforeRequest", //custom data row before Request
  needReloadAfterUpdateFields: "needReloadAfterUpdateFields", //bao gom fNeedReloadAfterUpdateFields
}

// KMB(key more button): là các key config more cho header button, là các nút thường sẽ xuất hiện trên header của 1 page (Với các custom type page thì tùy thuộc vào thiết kế của page đó)
export const KMB = {
  apiCheckShowModal: "apiCheckShowModal",
  acceptType: "acceptType", //upload
  apiUrlAfter: "apiUrlAfter", //upload
  title: "title", //show title cua button
  tooltip: "tooltip", //show tooltip cua button, chua su dung
  fQuery: "fQuery", //su dung fQuery cho cac query request can thiet: modal type list_check
  queryCheckList: "queryCheckList", //list_check_api
  source: "source", //su dung de lay source tu options// modal type list_check
  apiCheckList: "apiCheckList", //su dung de lay api get list modal type list_check_api
  apiSubmit: "apiSubmit", //api submit for list_check_api\
  usingRequestSharedData: "usingRequestSharedData",
  pathData: "pathData", //path Data get list modal type list_check_api
  fText: "fText", //fText convert to Text modal type list_check_api
  fValue: "fValue", //fValue convert to Value modal type list_check_api
  list: "list", //for group
  autoOpenLink: "autoOpenLink", //open link new window
  needShowModalPage: "needShowModalPage", //cho type api sau khi goi api
  driverjs: "driverjs", //config driverjs cho tutor
  html: "html",
  htmlBase64: "htmlBase64", //chuyen html qua dang base64 để xài
  moreOfForm: "moreOfForm",
  defaultValuesOfForm: "defaultValuesOfForm",
  linkOpen: "linkOpen", // them phuong an cho open link after call api thay vi Data.FullPath
}

// KMF(key more form): là các key config more cho 1 form cụ thể
export const KMF = {
  typeWrapControl: "typeWrapControl",
  defaultConfigWrapControl: "defaultConfigWrapControl",
  btnSubmit: "btnSubmit", //config button submit {title}
  btnReset: "btnReset",
  hideFooter: "hideFooter", //an footer
  noValidateDefault: "noValidateDefault", //tat validate mac dinh
  positionButtonsBottom: "positionButtonsBottom", //left right
  moreButtons: "moreButtons", //array button
  usingI18n: "usingI18n",
  fieldsRequired: "fieldsRequired",
  fieldsRequiredByCondition: "fieldsRequiredByCondition",
  fieldsDes: "fieldsDes",
  focusBySelector: "focusBySelector",
  msgRequired: "msgRequired",
  noEnterSubmit: "noEnterSubmit", //chan viec enter input tu dong goi submit
  noFormSubmit: "noFormSubmit", //tắt event onSubmit của form
  configApiAfterChange: "configApiAfterChange",
  closeMyModalAfterSubmit: "closeMyModalAfterSubmit", //@default: true, ẩn modal sau khi submit nếu form trong modal
}

// KMTF(key more table filter): là các key config more cho control filter ở table
export const KMTF = {
  isServer: "isServer", //boolean, có query filter server hay ko
  fQueryStart: "fQueryStart", //field query filter server giá trị from date, mặc định là FromDate, lưu ý cần khác field của column config filter chứ ko sẽ bị remove khi filter server
  fQueryEnd: "fQueryEnd", //field query filter server giá trị to date, mặc định là ToDate, lưu ý cần khác field của column config filter chứ ko sẽ bị remove khi filter server
}

// KMC(key more control): là các key config more cho control trong 1 form (form control)
export const KMC = {
  hasTextFilter: "hasTextFilter",
  styledCSS: "styledCSS",
  disabled: "disabled",
  placeholder: "placeholder",
  typeWrapControl: "typeWrapControl",
  configWrapControl: "configWrapControl",
  multi: "multi",
  select2: "select2", //more props of select2
  flatpickr: "flatpickr", //more props of flatpickr
  fMinDate: "fMinDate", //set min date cho control flatpickr từ 1 field khác trong form
  fMaxDate: "fMaxDate", //set max date cho control flatpickr từ 1 field khác trong form
  daterangepicker: "daterangepicker", //initialSettings của daterangepicker ở type datefromto
  items: "items", //danh cho cac kieu layout
  styleWrapControl: "styleWrapControl",
  optionKey: "optionKey",
  isText: "isText", //kieu date text
  isOnlyTime: "isOnlyTime", //only time for date
  conditionShow: "conditionShow", //condition show
  relativeTo: "relativeTo", //relativeTo
  relativeFrom: "relativeFrom", //relativeFrom
  effectedBy: "effectedBy",
  htmlWhenHide: "htmlWhenHide", //html when hide
  hideCondition: "hideCondition",
  conditionHide: "conditionHide", //tuong tu voi hideCondition
  defaultValue: "defaultValue", //defaultValue trong truong hop muon co default value rieng
  colorType: "colorType", //color type dung cho cai kieu su dung warning/success/danger
  fColorType: "fColorType", //color type nhưng lấy từ giá trị field trong form
  typeInput: "typeInput", // tuong tu typeInput ben cell
  apiMethod: "apiMethod",
  apiUrl: "apiUrl", //goi api
  apiUpdateOptions: "apiUpdateOptions", //cấu hình khi uống updateOptions sau khi đổi value control, Ref: formcontrol.more.apiUpdateOptions
  mapFields: "mapFields", //dung trong kieu select_table_api
  extraData: "extraData", //dung mo ta extraData khi co table
  canAddNewRow: "canAddNewRow", //show add new row
  defaultObjNewRow: "defaultObjNewRow", //obj default khi add new
  maxRow: "maxRow", //max row can add new
  titleAddNewRow: "titleAddNewRow",
  configClientTable: "configClientTable", //config Table
  pathData: "pathData",
  classControl: "classControl",
  appendComponent: "appendComponent",
  prependComponent: "prependComponent",
  configAppend: "configAppend",
  configPrepend: "configPrepend",
  hint: "hint",
  required: "required",
  screenCode: "screenCode", //dung cho cccd
  fId: "fId", //dung cho cccd
  fFront: "fFront",
  fBack: "fBack",
  acceptType: "acceptType",
  showClear: "showClear", //show nút clear cho 1 vài control cần nút clear
  clearValue: "clearValue", //giá trị khi clear, mặc định là null
  fgCheckValid: "fgCheckValid",
  checkValidAfterLostFocus: "checkValidAfterLostFocus",
  showRequiredMsg: "showRequiredMsg",
  requiredMsg: "requiredMsg",
  invalidMsg: "invalidMsg", //msg show khi bi invalid
  invalidMsgSystem: "invalidMsgSystem", //msg của hệ thống khi invalid dạng required
  invalidMsgInControl: "invalidMsgInControl", //msg invalid của control tự check valid riêng như text_pattern, object_editor
  patternRegex: "patternRegex", //pattern check valid cho type text_pattern
  deniedEmpty: "deniedEmpty", //không cho phép để rỗng khi gắn pattern Regex ở type text_pattern, mặc định là cho phép
  minLength: "minLength", //qui định kí tự tối thiếu của chuỗi, type text_pattern
  maxLength: "maxLength", //qui định kí tự tối thiếu của chuỗi, type text_pattern
  needCheckValidFromControl: "needCheckValidFromControl", //dung để check valid sau khi lost focus control co tự check valid
  step: "step",
  sameChange: "sameChange", //se thay doi gia tri field tuong ung voi field o OptionItem {fNeedChange:fInOptionItem}
  hideVisibility: "hideVisibility", // ==true se hide bang cach gan style hideVisibility = hidden
  noNegative: "noNegative",
  noDecimal: "noDecimal", //ko cho nhập số thập phân của input số
  focusToSelect: "focusToSelect", //khi click ô tự động tô chọn hết giá trị của input
  maxData: "maxData", //dung cho cai kieu select show ra bi chan neu data bi nhieu
  styleBase: "styleBase", //style cua Base control
  style: "style",
  showSearch: "showSearch",
  htmlEditorLib: "htmlEditorLib",
  morePropsCK5: "morePropsCK5",
  hideZero: "hideZero", //ko show gì khi giá trị là 0, dùng cho các kiểu input số
  hideNull: "hideNull", //ko show gì khi giá trị là null, dùng cho các kiểu input số
  tabIndex: "tabIndex",//set tabIndex cho contron number
  min: "min", //giá trị min của input số
  max: "max", //giá trị max của input số
  maxDecimal: "maxDecimal", //số lượng số thập phân tối đa của input số
  configLocale: "configLocale",
  prefix: "prefix", //kí tự prefix của input số
  suffix: "suffix", //kí tự suffix của input số
  theme: "theme",
  allowHalf: "allowHalf", //for rate_half
  allowClear: "allowClear", //for rate_half
  total: "total",
  configMask: "configMask", //config cho type text_mask
  allowEnterToSubmit: "allowEnterToSubmit",
  submitOnChange: "submitOnChange",
  clickToSelect: "clickToSelect",
  usingFormUUID: "usingFormUUID", //su dung formUUID cho Id cua files
  usingColorOptions: "usingColorOptions",
  allowRequestAfterChange: "allowRequestAfterChange", //danh cho kieu table
  configApiSourceData: "configApiSourceData",
  keysMoreSourceList: "keysMoreSourceList", // array string, dùng cho type table, là các key lấy từ options của màn hình để sử dụng cho form control table, các cell type select trong table sử dụng
}

//More of chart
export const KMChart = {
  colorsFollowTitle: "colorsFollowTitle", //support google chart: set colors dựa theo title
  usingFTicks: "usingFTicks", //support google chart: sử dụng field trong extradata để làm ticks
  showWithoutData: "showWithoutData", //support google chart: có show chart ngay cả ko có data hay ko
  removefYIfNotExist: "removefYIfNotExist", //support google chart: remove fY nếu nó ko có trong data chart
}

// các key config more cho kiểu table cell hoặc form control dạng number
const moreOfNumeral = [
  KMC.hideZero,
  KMC.hideNull,
  KMC.min,
  KMC.max,
  KMC.maxDecimal,
  KMC.prefix,
  KMC.suffix,
  KMC.allowEnterToSubmit,
  KMC.noDecimal,
  KMC.focusToSelect,
  KMC.maxLength,
  KMC.tabIndex,
]
export const FlowGetMoreForNumeral = (more = {}) => {
  let _more = {}
  for (let k of moreOfNumeral) {
    if (more.hasOwnProperty(k)) {
      _more[k] = more[k]
    }
  }
  return _more
}

export const FlowGetStringOfMoreFromRow = ({ key, row, more, df } = {}) => {
  let _value = df
  let _fKey = `f${key.charAt(0).toUpperCase() + key.slice(1)}`
  if (row && more[_fKey] && row.hasOwnProperty(more[_fKey])) {
    _value = row[more[_fKey]]
  } else if (more.hasOwnProperty(key)) {
    _value = more[key]
  }
  return _value
}

export const FlowGetBoolOfMoreFromRow = ({ key, row, more, df } = {}) => {
  let _value = df || false
  let _fKey = `f${key.charAt(0).toUpperCase() + key.slice(1)}`
  if (row && more[_fKey] && row.hasOwnProperty(more[_fKey])) {
    _value = row[more[_fKey]]
  } else if (more.hasOwnProperty(key)) {
    _value = more[key]
  }
  return _value
}

export const FlowGetConfigOfMoreFromRow = ({
  key,
  row,
  more,
  df,
  parseConfig,
} = {}) => {
  let _config = { ...df }
  if (key && key.length > 0) {
    let _configKey = `config${key.charAt(0).toUpperCase() + key.slice(1)}`
    let _fKey = `f${key.charAt(0).toUpperCase() + key.slice(1)}`
    if (row && more[_fKey] && row.hasOwnProperty(more[_fKey])) {
      _config.value = row[more[_fKey]]
      _config.show = true
    } else if (more.hasOwnProperty(key)) {
      _config.value = more[key]
      _config.show = true
    }

    if (more[_configKey]) {
      if (parseConfig) {
        parseConfig({ config: more[_configKey], row })
      }
      _config = { ..._config, ...more[_configKey] }
      if (
        row &&
        more[_configKey][_fKey] &&
        row.hasOwnProperty(more[_configKey][_fKey])
      ) {
        _config.value = row[more[_configKey][_fKey]]
        _config.show = true
      } else if (more[_configKey].hasOwnProperty(key)) {
        _config.value = more[_configKey][key]
        _config.show = true
      }
    }
  }
  return _config
}

/*
* Ref List *
Một số các config và định nghĩa dùng chung
{
  "ui.color": "primary" | "secondary" | "success" | "warning" | "danger", //qui định màu sắc theo ý nghĩa, thường thì primary là xanh dương, secondary: màu xám, success: xanh lá, warning: cam, danger: đỏ
}
*/
/*
Config 1 Header Button trả về từ server trong api Options
{  
  "options.button": {
    "Color_BG": string | null,      // Màu sắc background, dạng mã hex, ít khi dùng
    "Color": ui.color | null,       // Màu sắc của bút theo ý nghĩa, ít khi dùng
    "OpenMode": null | "NewWindow", // Dùng cho type link, null thì mở link ở màn hình hiện tại, "NewWindow" mở ở tab mới
    "APIName": string | null,       // Api dùng cho type api hoặc các type nào cần request api
    "MethodType": "POST" | "GET",   // Dùng cho type api, là method khi request, mặc định là POST, ít khi dùng
    "NeedReload": boolean,          // Dùng để sau check khi request api thì có reload lại màn hình
    "NeedReloadList": boolean,      // Dùng để sau check khi request api thì có reload lại api list của table
    "Form": object | null,          // Config form cho type form hoặc các type có dùng tới form
    "RequestData": object | null,   // Data request kèm theo nếu có gọi request api
    "ConfirmMsg": string | null,    // Msg xác nhận trước khi request api của type api
    "More": json string | null,     // Config more cho từng type
    "Type": string | null,          // Type của nút
    "Icon": string | null,          // Show icon trên nút
    "Name": string | null,          // Title của nút
    "Code": string | null,          // Ko dùng tới
    "Url": string | null,           // Là url mở link với type link
  },
  "options.item": {Value: string,Text: string,ColorCode: string}, // 1 item option là object gồm có Value, Text, ColorCode
  "options.sourceData": [options.item], // 1 sourceData là 1 mảng các options.item
}
*/

/*
Một số config chi tiết của table cell more
{
  "cell.more.configPinmap": { //config Pinmap cho cell readonly_pinmap
    showPin: boolean,         //@default: true, có show icon pin ko
    iconPin: string,          //config icon pin  
    titlePin: null,           //tilte show bên dưới icon pin
    stylePin: null,           //custom style pin
    hideData: boolean,        //@default: false, có ẩn data lat lng ko
    hasLinkGGMap: boolean,    //@default: false, có gắn link google map để click vào mở ra hay ko
    showGGMapInIframe: true,  //@default: true, mở map bằng cửa sổ mới hay là mở bằng modal chèn iframe bên trong
    z: number,                //@default: 15, độ zoom của bảng đồ khi xem
    modal: object,            //custom config modal khi mở bảng đồ trong modal
  },
  "cell.more.configBadge":{ //config badge để show các số cho kiểu cell expand, files v.v...
    show: boolean,        //show badge hay ko
    style: object style,  //custom style cho badge,
    fCount: string,       // sử dụng data trên row để lấy count show trên badge
    fColor: string,       // sử dụng data color trên row để làm màu nền cho badge
    colorByMapCount: object,  //custom color nền của badge dựa vào count theo thứ tự
    showEmpty: boolean,   //@default false, có show count khi count = 0 hay ko
  },
  "cell.more.button": {
    title: string,  // title, text hiển thị của button
    fTitle: string, // là field trên row, sử dụng để lấy giá trị từ row[fTitle] làm title, ưu tiên hơn field title
    icon: string,   // là className của thẻ i, fontAwesome để show thêm icon phía bên trái title cho nút,
    style: object,  // custom style cho nút
    className: string,      // thêm class cho nút
    titleTooltip: string,   // title tooltip mặc định cho nút, có thể sủ dụng định dạng field trong ngoặc [field] để lấy giá trị thêm từ row
    fTitleTooltip: string,  // là field trên row, sử dụng để lấy giá trị từ row[fTitleTooltip] làm title tooltip cho nút, ưu tiên hơn titleTooltip
  },
  "cell.more.configTitleTooltip":{  // là tooltip mặc định của hệ thống khi hover vào các nút hoặc vùng nào đó
    title: string,  // fix cứng giá trị title
    fTitle: string, // là field trên row, sử dụng để lấy giá trị từ row[fTitle] làm title ưu tiên hơn field title
  },
  "cell.more.configFile":{
    acceptType?: string,
    fAcceptType?: string,           //field trên row thay cho acceptType, ưu tiên hơn acceptType nếu có
    needRequestPhotos?: boolean,    //@default true,
    pasteAsFile?: boolean,          //@default true, có cho ctrl + v để paste file đã copy vào thay cho chọn file upload ko
    showUploadFromGGDrive?: boolean,//@default false, có show nút upload file từ google drive ko
    showChangeAvatar?: boolean,     //@default true, có cho phép đổi hình đại diện ko
    previewFullSize?: boolean,      //@default true, có cho xem full size hình ko
    showOpenLink?: boolean,         //@default true, có show nút mở link file ko
    showFileSize?: boolean,         //có show kích thước file ko
    hideBtnUpload?: boolean,        //gán true nếu muốn ẩn nút upload ở view file manager dù có thể được upload
    screenCode?: string             //custom screencode, mặc định lấy screencode của page
    customRequestData?: object,     //bổ sung requestData khi request các api load photo, upload, có thể overide ScreenCode, Id, ProjectId
  }
}
*/

/*
Một số config chi tiết của form control more
{
  "formcontrol.more.apiUpdateOptions": {
    url: string, //url api
    method?: string, //@default "POST", method request api
    pathData?: string, //@default "Data", path để lấy data từ response
    queryFromForm?: obj, //lấy value từ form để gửi kèm request api, với key là field truyền lên, value là field của form    
  },  
}
*/

/**
 * Table Cell
 * - Muốn việc chọn source data từ 1 source list con của 1 source list khác và dựa theo value 1 ô khác
 *  VD: chọn huyện từ tỉnh -> có danh sách tỉnh, mỗi tỉnh có danh sách huyện bên trong
 *  Giải pháp: sau khi chọn ô tỉnh -> có value tỉnh, lấy source item của tỉnh từ source list tỉnh -> lấy source list huyện để chọn
 *  Cách làm: options key theo cú pháp: optionKeyTinh.[FieldValueTinh].optionKeyHuyen
 * - Muốn việc chọn source data cho các type select đc quyết định từ ngoài page?
 */
